import { render } from "./TimelinePeriod.vue?vue&type=template&id=5167bdd2&scoped=true&ts=true"
import script from "./TimelinePeriod.vue?vue&type=script&lang=ts"
export * from "./TimelinePeriod.vue?vue&type=script&lang=ts"

import "./TimelinePeriod.vue?vue&type=style&index=0&id=5167bdd2&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5167bdd2"]])

export default __exports__